import { ParticleSphere } from './model/particle-sphere'
import { HomeTitle } from './content/home-title'
import { HomeInfoGrid } from './content/home-info-grid'
import { AvailabilityStatus } from './content/availability-status'
import { useState, useEffect, useRef } from 'react'

export function Home() {
  const [isInView, setIsInView] = useState(true);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { threshold: 0 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef}
      id="home" 
      className="relative w-full min-h-[100svh] overflow-hidden flex flex-col bg-transparent"
    >

      <div 
        className="absolute inset-0 bg-transparent pointer-events-none"
        style={{ opacity: isInView ? 1 : 0 }}
      >
        <ParticleSphere />
      </div>

      {/* Main Layout Container */}
      <div className="relative z-10 flex-1 flex flex-col w-full pb-6 md:pb-10 pt-20 md:pt-24 px-6 md:px-16 pointer-events-none">
        
        {/* Title Section (Flex grow, centers content, prevents overlap) */}
        <div className="flex-1 flex flex-col justify-center w-full min-h-0 py-8">
           <HomeTitle />
        </div>

        {/* Bottom Section (Fixed at bottom) */}
        <div className="w-full flex-shrink-0 mt-auto max-w-7xl mx-auto">
           <HomeInfoGrid>
             <AvailabilityStatus />
           </HomeInfoGrid>
        </div>

      </div>
    </section>
  )
}
